import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { isExistPhoneNumberAction, RESET_IS_EXIST } from '../redux/auth/auth.actions';
import { getCountryList } from '../redux/survey/survey.actions';
import { toast } from 'react-toastify';
import CountryFlag from '../components/CountryFlag/CountryFlag';

const GetPhone = () => {
  const [phone, setPhone] = useState('');
  const [phoneCode, setPhoneCode] = useState("+39");
  const [error, setError] = useState('');
  const [isExistChecked, setIsExistChecked] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isExistPhoneNumber, isLoading, errorMsg } = useSelector((state) => state.authInfo);
  const currentLanguage = localStorage.getItem("language");

  const location = useLocation();
  const { surveyId } = location.state || {};

  useEffect(() => {
    dispatch(getCountryList());
  }, [dispatch]);

  useEffect(() => {
    if (isSubmitted && isExistChecked) {
      if (isExistPhoneNumber?.isExist) {
        toast.error(currentLanguage === "Italian" ? "Numero di telefono già registrato" : "Phone number already registered");
      } else if (!errorMsg?.isExist) {
        localStorage.setItem("registerData", JSON.stringify({ phone: phone, countryCode: phoneCode }));
        navigate('/auth/verify-mobile-otp', { state: { phone: phone, countryCode: phoneCode, from: '/getPhone', surveyId: surveyId } });
      }
    }
  }, [errorMsg, isExistPhoneNumber, phone, phoneCode, currentLanguage, isLoading]);

  const validatePhone = (phone) => /^\d{10}$/.test(phone);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setPhone(value);
    setError('');
    setIsExistChecked(false);
    dispatch({ type: RESET_IS_EXIST });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    
    if (!phone.trim()) {
      setError(currentLanguage === "Italian" ? 'Inserisci il tuo numero di telefono' : 'Please insert your phone number');
      const toastMessage = currentLanguage === "Italian"
        ? "Chiediamo di verificare il numero di cellulare per garantire che tutti i nostri utenti siano persone reali. È necessario per offrire un'esperienza autentica nei nostri sondaggi, evitando rischio di account falsi. Grazie per la comprensione!"
        : "We ask you to verify your mobile number to ensure all our users are real people and not bots. This helps us provide you with a genuine survey experience, free from fake accounts. Thanks for understanding!";
      toast.info(toastMessage);
      return;
    }

    if (!validatePhone(phone)) {
      setError(currentLanguage === "Italian" ? 'Numero di telefono non valido' : 'Invalid phone number');
      return;
    }

    if (!isExistChecked) {
      await dispatch(isExistPhoneNumberAction(phone));
      setIsExistChecked(true);
      setIsSubmitted(true);
    }
  };

  return (
    <div className='get_phone_wrapper' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '20vh' }}>
      <div className="top_text mb15" style={{ textAlign: 'center' }}>
        {currentLanguage === "Italian" ? 'Inserisci il tuo numero di cellulare per continuare.' : 'Enter your mobile number to continue.'}
      </div>
      <form onSubmit={handleSubmit} style={{ width: '100%', maxWidth: '400px' }}>
        <div className="input_wrapper mobile">
          <CountryFlag setPhoneCode={setPhoneCode} language={currentLanguage} />
          <input
            type="text"
            placeholder={currentLanguage === "Italian" ? 'Numero di cellulare' : 'Mobile Number'}
            value={phone}
            onChange={handleInputChange}
            maxLength={10}
          />
        </div>
        {error && (
          <div className="error-text" style={{ color: 'red', fontSize: '12px', marginTop: '-10px', textAlign: 'left' }}>
            {error}
          </div>
        )}
        <div className="action mb15" style={{ display: 'flex', justifyContent: 'center' }}>
          <button type="submit">
            {currentLanguage === "Italian" ? 'Invia' : 'Send'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default GetPhone;